import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["align", "arrowsNode", "children"];
import styled from 'foundations-theming/utils';
import { isIE11 } from '../../../utils/BrowserTest';
import { filterProps } from '../../../../utils/filterProps';
import { useMapTokenPropsToCSS } from '../../../../hooks/useMapTokenPropsToCSS';
import { useTableStyles } from '../Table.styles';
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledContent = styled.div.withConfig({
  displayName: "SortTH_Content__StyledContent",
  componentId: "sc-137v4nh-0"
})(({
  $align,
  $cssStyles
}) => {
  const {
    tableHeaderHeight
  } = useTableStyles();
  return Object.assign({
    display: 'flex',
    alignItems: 'center'
  }, $align === 'right' && {
    marginLeft: 'auto',
    textAlign: 'right'
  }, isIE11() && {
    height: tableHeaderHeight
  }, $cssStyles);
});
export const SortTH_Content = _ref => {
  let {
      align,
      arrowsNode,
      children
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    domProps,
    callbackProps,
    restProps,
    tokenProps
  } = filterProps(rest);
  const cssStyles = useMapTokenPropsToCSS(tokenProps);
  return /*#__PURE__*/_jsxs(StyledContent, Object.assign({}, domProps, callbackProps, restProps, {
    $align: align,
    $cssStyles: cssStyles,
    children: [children, arrowsNode]
  }));
};